import axios from "axios";

// -------- ANALYTICS (GA-style: Users = persistent visitor_id, Sessions = per tab) --------

const VISITOR_ID_KEY = 'humqadam_visitor_id';
const SESSION_ID_KEY = 'humqadam_session_id';

// Persistent visitor ID (localStorage) – same browser = 1 user across sessions/tabs
const getVisitorId = () => {
  if (typeof localStorage === 'undefined') return null;
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = 'web_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
};

// Session ID (sessionStorage) – new per tab; session ends when tab closes
const getSessionId = () => {
  if (typeof sessionStorage === 'undefined') return null;
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = 's_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9);
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};

// Track analytics event
export async function trackEvent({
  event_type = 'page_view',
  page = null,
  offence = null,
  organization = null,
  province = null,
  district = null,
  search_term = null,
  language = null,
}) {
  try {
    await axios.post(`${process.env.REACT_APP_LOCAL_API}/analytics/track`, {
      event_type,
      platform: 'web',
      page,
      offence,
      organization,
      province,
      district,
      search_term,
      language,
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience for analytics
    console.debug('Analytics tracking error:', error);
  }
}

// Convenience functions for common events
export const trackPageView = (page, { province, district, language } = {}) => 
  trackEvent({ event_type: 'page_view', page, province, district, language });

export async function trackAppOpen({ province, district, language } = {}) {
  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('humqadam_app_open_sent')) return;
  await trackEvent({ event_type: 'app_open', page: 'home', province, district, language });
  if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('humqadam_app_open_sent', '1');
}

export const trackSearch = (search_term, { province, district, language } = {}) => 
  trackEvent({ event_type: 'search', search_term, province, district, language });

// Required for admin dashboard analytics – do not remove
export const trackOffenceView = (offence, { province, district, language } = {}) =>
  trackEvent({ event_type: 'offence_view', offence, province, district, language });

export const trackOrganizationView = (organization, { province, district, language } = {}) =>
  trackEvent({ event_type: 'organization_view', organization, province, district, language });

export const trackLawView = (page, { province, district, language } = {}) =>
  trackEvent({ event_type: 'law_view', page, province, district, language });

export const trackGuidanceView = (offence, { province, district, language } = {}) =>
  trackEvent({ event_type: 'guidance_view', offence, province, district, language });

